export default {
    active: 'Active',
    inactive: 'Deactive'
}
